<!--
 * @Description: 查看材料
 * @Author: ll
 * @Date: 2021-9-7 16:03:30
 * @LastEditTime: 
 * @LastEditors: ll
-->
<template>
  <div class="bq-checkMaterial cr-bg-white-1 cr-p-2">
    <!-- 头部 -->
    <div slot="title" class="cr-flex cr-jc-between cr-ai-center">
      <div class="cr-bold cr-text-black-1">
        <!-- <span>案件管理 > </span> -->
        <router-link to="/businessCenter/caseManage" class="cr-cursor cr-text-black-1 cs-text-dec">案件管理 > </router-link>
        <span>{{ checkData.attachmentName }}</span>
      </div>
      <div>
        <span>收文时间：{{ checkData.createdAt }}</span>
        <a-button class="cr-ml-1 cr-bg-primary cr-text-white-1" @click="downFile" :loading="loading">下载文件</a-button>
      </div>
    </div>
    <!-- 内容 -->
    <div class="bq-checkContent cr-mt-2" v-if="checkData.attachmentName !== '客户核对表'">
      <img v-if="flag" :src="checkData.previewUrl[0]" alt="" />
      <iframe v-else :src="checkData.previewUrl" class="w-100 h-100 cr-iframe" frameborder="0"></iframe>
    </div>
    <div class="bq-checkContent cr-mt-2" v-else>
      <div class="bq-according cr-mb-2">
        <img :src="checkData.previewUrl[checkIndex]" />
      </div>
      <div class="bq-switch cr-flex">
        <span :class="{ active: index == checkIndex }" v-for="(Check, index) in checkData.previewUrl" :key="index" @click="checkSwitch(index)">{{ index + 1 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { urlToFileDown } from '@/api/cannotEdit.js'
export default {
  data() {
    return {
      checkData: {},
      flag: false,
      checkIndex: 0,
      loading: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.checkData = JSON.parse(this.$route.query.item)
      console.log(this.checkData)
      if (this.checkData.attachmentName !== '客户核对表') {
        if (this.checkData.previewUrl[0].slice(-3) === 'png' || this.checkData.previewUrl[0].slice(-3) === 'jpg') {
          this.flag = true
        }
      }
    },
    checkSwitch(index) {
      this.checkIndex = index
    },
    // 下载文件
    downFile() {
      let url = ''
      if (this.checkData.attachmentUrl.slice(-4) === '.pdf') {
        this.loading = true
        urlToFileDown(this.checkData.attachmentUrl)
          .then((res) => {})
          .catch((err) => console.log(err))
        this.loading = false
        let environment = process.env.NODE_ENV == 'production' ? 'https://bq.gongsibao.com' : 'https://bqtest.gongsibao.com'
        url = `${environment}/api/upload/urlToFileDown?fileUrl=${this.checkData.attachmentUrl}`
      }
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url || this.checkData.attachmentUrl
      link.setAttribute('download', `${this.checkData.attachmentName}`)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style lang="less" scoped>
.bq-checkMaterial {
  .cs-text-dec {
    text-decoration: none;
  }
  .bq-checkContent {
    border: 1px solid #f0f0f0;
    border-radius: 1px;
    // height: calc(100vh - 163px);
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
    .cr-iframe {
      height: calc(100vh - 163px);
    }
    .bq-according {
      width: 100%;
      height: 93%;
      border-radius: 3px;
      border: 1px solid #d9d9d9;
      img {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    }
    .bq-switch {
      span {
        display: inline-block;
        border-radius: 50%;
        line-height: 24px;
        width: 24px;
        height: 24px;
        background: #f0f0f0;
        margin-left: 12px;
        color: #999;
        text-align: center;
        cursor: pointer;
      }
      .active {
        background: rgba(71, 186, 151, 0.1);
        color: #47ba97;
      }
    }
  }
}
</style>
